import { useEffect, useRef } from "react";

// Utility: Check if two rectangles overlap
function isOverlapping(rect1, rect2) {
  return !(
    rect1.right <= rect2.left ||
    rect1.left >= rect2.right ||
    rect1.bottom <= rect2.top ||
    rect1.top >= rect2.bottom
  );
}

export default function OverlapChecker() {
  const itemsRef = useRef([]);

  const items = [
    { id: 1, text: "Item 1", style: { top: 40, left: 10 } },
    { id: 2, text: "Item 2", style: { top: 0, left: 20 } },
    { id: 3, text: "Item 3", style: { top: 0, left: 50 } },
    { id: 4, text: "Item 4", style: { top: 0, left: 60 } },
  ];

  useEffect(() => {
    const rects = itemsRef.current.map((el) => el?.getBoundingClientRect());
    const overlaps = [];

    for (let i = 0; i < rects.length; i++) {
      for (let j = i + 1; j < rects.length; j++) {
        if (rects[i] && rects[j] && isOverlapping(rects[i], rects[j])) {
          overlaps.push([items[i].id, items[j].id]);
        }
      }
    }

    console.log("Rects:", rects);
    if (overlaps.length > 0) {
      console.log("Overlapping pairs:", overlaps);
    } else {
      console.log("No overlaps detected");
    }
  }, []);

  return (
    <div
      style={{ position: "relative", height: 200, border: "1px solid black" }}
    >
      {items.map((item, index) => (
        <div
          key={item.id}
          ref={(el) => (itemsRef.current[index] = el)}
          style={{
            position: "relative",
            top: item.style.top,
            left: item.style.left,
            width: 60,
            height: 30,
            background: "lightblue",
            border: "1px solid blue",
          }}
        >
          {item.text}
        </div>
      ))}
    </div>
  );
}
